import React from 'react';
import './Aboutus.css';
import { FaUsers, FaLightbulb, FaChartLine, FaTrophy } from 'react-icons/fa';

function Aboutus() {
  return (
    <div className="aboutus-container">
      {/* Hero section with image and overlay text */}
      <div className="aboutus-hero">
        <div className="aboutus-overlay">
          <h1>ABOUT US</h1>
        </div>
      </div> 

      {/* White gap */}
      <div className="white-gap"></div>

      {/* Colored background section with boxes */}
      <div className="aboutus-info-section">
        <div className="aboutus-color-overlay"></div>

        <div className="aboutus-boxes">

          <div className="aboutus-box">
            <div >
              <img className='about-logo' src='./Logo/logob.png' />
            </div>
            <p>8 years of experience established since 2018.</p>
          </div>
          <div className="aboutus-box">
            <div>
              <img className='about-logo' src='./Logo/logob.png' />
            </div>
            <p>Centrex Marine Services is proudly connected to a trusted global logistics network, enabling seamless freight forwarding and supply chain solutions across international markets.</p>
          </div>
          <div className="aboutus-box">
            <div>
              <img className='about-logo' src='./Logo/logob.png' />
            </div>
            <p>Our impending goal is to emerge as a leading global logistics provider of integrated supply chain solutions by meeting the modern and diverse requirements of flexibility and reliability.</p>
          </div>
            <div className="aboutus-box">
            <div >
              <img className='about-logo' src='./Logo/logob.png' />
            </div>
            <p>Centrex Marine Services offers fast and reliable air freight solutions tailored to your business needs. Whether it's urgent shipments or high-value cargo, we ensure safe and timely delivery across the globe through our strong airline partnerships and efficient handling processes.</p>
          </div>
        </div>
      </div>

      {/* White gap */}
      <div className="white-gap"></div>
    </div>
  );
}

export default Aboutus;
